import Enum from '../../utils/enum'

const Networks = new Enum([
  'PATIENT',
  'PROVIDER',
])

export default Networks
